require('@rails/ujs').start();
require('@rails/activestorage').start();
require('channels');
require('@popperjs/core');

import 'bootstrap';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'material-icons/iconfont/material-icons.css';

import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import VCalendar from 'v-calendar';

Vue.use(VCalendar);

require('../warehouses/check_prices/stylesheets/application.scss')

const reCaptchaSiteKey = process.env.NODE_ENV === 'production' ? '6LfG2l4iAAAAAJjrvBMn-shpGrUVwzAjSM7e3M99' : '6Lc0HL8iAAAAAASeA9XSFm5Ipgi2iMOVRfDmGdO7';

Vue.use(VueTelInput);
Vue.use(VueAxios, axios);
Vue.use(VueReCaptcha, {
  siteKey: reCaptchaSiteKey,
  loaderOptions: {
    autoHideBadge: true
  }
});

import App from '../warehouses/mexican_bot/App.vue';

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    render: h => h(App)
  }).$mount();

  document.querySelector('#vuejs-application-container').appendChild(app.$el);
});
